var generateStyle = function generateStyle(componentTheme) {
  return {
    rangeSeparator: {
      margin: '0',
      padding: "".concat(componentTheme.separatorPadding, " ").concat(componentTheme.separatorPadding, " 0 ").concat(componentTheme.separatorPadding),
      fontFamily: componentTheme.fontFamily,
      fontWeight: componentTheme.boldFontWeight
    },
    filterItem: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row',
      margin: '0',
      paddingBottom: componentTheme.filterItemPadding
    },
    sectionWrapper: {
      display: 'inline-block',
      fontFamily: componentTheme.fontFamily,
      fontSize: componentTheme.fontSize,
      paddingBottom: componentTheme.sectionWrapperPadding
    },
    container: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
};
export default generateStyle;